export default __webpack_public_path__ + "static/media/480_private01-nl-mobile.a05a4efa.png";